import { hc } from 'hono/client';
import type { AppType } from '@mybusinessmate/api';

export type ClientOptions = Parameters<typeof hc>[1];

/**
 * Creates a type-safe RPC client for the MyBusinessMate API.
 * Uses native hono/client with AppType inferred directly from Hono routes.
 * Sends the Better Auth session cookie on every call (`credentials: 'include'`).
 * `baseUrl` may be '' for same-origin relative URLs (the Vite dev proxy case).
 */
export const createApiClient = (baseUrl: string, options?: ClientOptions) => {
  return hc<AppType>(baseUrl, { ...options, init: { credentials: 'include', ...options?.init } });
};

export type ApiClient = ReturnType<typeof createApiClient>;
export type { AppType } from '@mybusinessmate/api';

export * from './auth-client';
export * from './errors';
